import { render, staticRenderFns } from "./CmgUnsupportedBrowser.vue?vue&type=template&id=52427e78&scoped=true&lang=pug"
import script from "./cmg-unsupported-browser.ts?vue&type=script&lang=ts&external"
export * from "./cmg-unsupported-browser.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgUnsupportedBrowser.vue?vue&type=style&index=0&id=52427e78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52427e78",
  null
  
)

export default component.exports